import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"block":"","depressed":"","outlined":_vm.outlined,"color":_vm.button.color},on:{"click":_vm.handleClick}},[_c(VIcon,{staticClass:"pr-1"},[_vm._v(" "+_vm._s(_vm.button.icon)+" ")]),_vm._v(" "+_vm._s(_vm.button.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }